import { newsList } from "@/mocks/news";
import { worksList } from "@/mocks/works";
import type { DetailItem } from "@/types";

export function getDetailById(id: string): DetailItem | null {
  if (id.startsWith("news-")) {
    const item = newsList.find((n) => n.id === id);
    if (!item) return null;
    return {
      kind: "news",
      id: item.id,
      title: item.title,
      image: item.image,
      summary: item.summary,
      date: item.date,
      meta: item.category,
      author: item.author,
      source: item.source,
      tags: item.tags,
      paragraphs: item.content,
      cast: [],
    };
  }
  if (id.startsWith("work-")) {
    const item = worksList.find((w) => w.id === id);
    if (!item) return null;
    return {
      kind: "work",
      id: item.id,
      title: item.title,
      image: item.cover,
      summary: item.summary,
      date: `${item.year}`,
      meta: `${item.type} · ${item.year}`,
      author: "风间由美工作室",
      source: "官方作品资料",
      tags: item.tags,
      paragraphs: item.content,
      cast: item.cast,
    };
  }
  return null;
}

export function getRelated(current: DetailItem, count = 3): DetailItem[] {
  if (current.kind === "news") {
    const same = newsList.filter(
      (n) => n.id !== current.id && n.category === current.meta,
    );
    const rest = newsList.filter(
      (n) => n.id !== current.id && n.category !== current.meta,
    );
    return [...same, ...rest].slice(0, count).map((n) => getDetailById(n.id)!);
  }
  const currentType = worksList.find((w) => w.id === current.id)?.type;
  const same = worksList.filter((w) => w.id !== current.id && w.type === currentType);
  const rest = worksList.filter((w) => w.id !== current.id && w.type !== currentType);
  return [...same, ...rest].slice(0, count).map((w) => getDetailById(w.id)!);
}

export function formatDate(value: string) {
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}